import React from 'react';
import Select from 'react-select';

const getFlagEmoji = (countryCode) =>
  countryCode
    .toUpperCase()
    .replace(/./g, char => String.fromCodePoint(127397 + char.charCodeAt()));

const CountrySelect = ({ value, onChange, isDisabled = false, options, placeholder }) => {
  const formatOptionLabel = ({ label, value }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span>{getFlagEmoji(value)}</span>
      <span>{label}</span>
    </div>
  );

  return (
    <Select
      options={options}
      value={value || null}
      onChange={onChange}
      placeholder={placeholder}
      isDisabled={isDisabled}
      formatOptionLabel={formatOptionLabel}
    />
  );
};

export default CountrySelect;
